"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../style/index"));

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Root = _createStyled["default"].div(_templateObject()),
    LabelHolder = _createStyled["default"].div(_templateObject2()),
    FieldWrapper = _createStyled["default"].div(_templateObject3()),
    Wrapper = _createStyled["default"].div(_templateObject4()),
    Input = _createStyled["default"].div(_templateObject5()),
    Textarea = _createStyled["default"].textarea(_templateObject6()),
    Shadow = _createStyled["default"].textarea(_templateObject7()),
    Border = _createStyled["default"].hr(_templateObject8()),
    ActiveBorder = _createStyled["default"].hr(_templateObject9()),
    Label = _createStyled["default"].label(_templateObject10());

function template() {
  var labelContent = null,
      _this$props = this.props,
      autoComplete = _this$props.autoComplete,
      autoFocus = _this$props.autoFocus,
      disabled = _this$props.disabled,
      id = _this$props.id,
      name = _this$props.name,
      readOnly = _this$props.readOnly,
      rows = _this$props.rows,
      defaultValue = _this$props.defaultValue,
      onKeyUp = _this$props.onKeyUp,
      onKeyDown = _this$props.onKeyDown,
      onChange = _this$props.onChange,
      maxLength = _this$props.maxLength,
      attribute = _this$props.attribute,
      label = _this$props.label,
      placeholder = _this$props.placeholder,
      floating = _this$props.floating,
      _this$props$className = _this$props.className,
      className = _this$props$className === void 0 ? '' : _this$props$className,
      _this$state = this.state,
      focus = _this$state.focus,
      height = _this$state.height,
      placeholderContent = null,
      styles = this.compileStyled(_index["default"]),
      value = this._stringify();

  if (label) {
    labelContent = _react["default"].createElement("div", null, _react["default"].createElement(LabelHolder, {
      styles: styles.labelHolder
    }, "\xA0"), _react["default"].createElement(Label, {
      styles: styles.label
    }, label));
  }

  if (placeholder && (!floating || // material: ph виден если нет лейбла
  !label || // material: ph виден в состоянии фокуса, если есть лейбл
  focus)) {
    placeholderContent = placeholder;
  }

  return _react["default"].createElement(Root, {
    className: className,
    styles: styles.root,
    onMouseEnter: this._handleHover,
    onMouseLeave: this._handleRootBlur
  }, _react["default"].createElement(Wrapper, {
    styles: styles.wrapper
  }, labelContent, _react["default"].createElement(FieldWrapper, {
    styles: styles.fieldWrapper
  }, _react["default"].createElement(Input, {
    styles: styles.input
  }, _react["default"].createElement(Textarea, {
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    disabled: disabled,
    id: id,
    name: name,
    readOnly: readOnly,
    rows: rows,
    styles: styles.field,
    defaultValue: defaultValue,
    value: value,
    onFocus: this._handleFocus,
    onBlur: this._handleBlur,
    onKeyUp: onKeyUp,
    onKeyDown: onKeyDown,
    onChange: onChange,
    placeholder: placeholderContent,
    maxLength: maxLength,
    ref: this._nativeElementRef,
    style: {
      height: height
    },
    "data-qa-node": attribute,
    "data-qa-value": value
  }), _react["default"].createElement(Shadow, {
    ref: this._shadowRef,
    value: this._stringify(),
    rows: 1,
    styles: styles.shadow,
    tabIndex: -1,
    "aria-hidden": "true",
    readOnly: true
  }))), _react["default"].createElement(Border, {
    styles: styles.border
  }), _react["default"].createElement(ActiveBorder, {
    styles: styles.activeBorder
  })));
}